var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsAllDayFreshness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "320.000000pt",
    height: "320.000000pt",
    viewBox: "0 0 320.000000 320.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,320.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1415 3134 c-324 -49 -601 -174 -834 -377 -253 -222 -434 -541 -497 -882 -26 -139 -26 -411 0 -550 116 -623 577 -1097 1204 -1238 83 -18 128 -22 312 -22 238 0 330 14 509 77 392 138 718 431 892 803 275 590 152 1284 -311 1745 -217 217 -468 354 -772 421 -71 16 -138 21 -283 24 -104 2 -203 1 -220 -1z m425 -99 c457 -75 856 -369 1060 -780 114 -230 153 -397 154 -650 1 -249 -39 -425 -144 -640 -112 -230 -282 -429 -486 -565 -138 -92 -220 -133 -363 -180 -161 -53 -286 -73 -461 -73 -238 0 -420 42 -637 148 -409 200 -692 568 -790 1025 -26 121 -26 439 0 560 63 296 193 538 402 745 340 339 795 487 1265 410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327 2663 c-32 -173 -32 -177 -13 -170 24 9 146 44 179 52 l28 6 -82 92 c-45 51 -85 96 -89 100 -4 5 -14 -31 -23 -80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950 2543 c0 -26 45 -243 50 -243 4 0 35 23 71 51 35 28 74 56 86 62 13 6 23 13 23 16 0 5 -153 86 -222 119 -5 2 -8 0 -8 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485 2444 c-145 -31 -294 -110 -411 -218 -187 -171 -297 -444 -280 -692 30 -438 361 -788 786 -830 l70 -7 0 882 0 881 -47 -1 c-27 0 -79 -7 -118 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710 2402 l0 -60 53 -7 c329 -41 589 -274 663 -592 34 -148 12 -348 -55 -488 -79 -166 -227 -307 -396 -378 -61 -25 -193 -57 -240 -57 -24 0 -25 -2 -25 -60 0 -59 0 -60 29 -60 53 0 195 31 261 57 251 99 438 298 523 556 25 77 30 114 35 221 3 82 0 154 -8 200 -68 384 -382 676 -777 721 l-63 7 0 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 2222 c10 -24 133 -212 139 -212 4 0 13 13 20 30 7 16 32 58 56 92 24 34 42 63 41 65 -2 1 -45 7 -97 13 -52 6 -110 13 -129 16 -18 3 -32 1 -30 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601 1849 c-57 -15 -105 -30 -108 -32 -2 -3 42 -39 99 -80 l103 -76 16 92 c10 51 20 100 24 110 10 23 -7 22 -134 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592 1455 c-57 -42 -102 -78 -100 -80 7 -7 230 -66 234 -62 3 3 0 24 -6 48 -6 24 -14 72 -18 107 l-7 63 -103 -76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708 1068 c-36 -57 -65 -104 -64 -105 3 -3 195 16 223 22 20 5 19 9 -28 87 -27 44 -49 85 -49 90 0 24 -23 -2 -82 -94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986 869 c-10 -30 -46 -222 -42 -226 2 -2 52 20 111 49 l107 54 -42 28 c-24 15 -62 46 -86 68 -30 28 -45 36 -48 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295 657 c2 -12 12 -65 21 -117 8 -52 17 -96 18 -98 2 -1 40 38 85 87 l81 89 -37 7 c-21 4 -68 17 -106 30 l-67 24 5 -22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAllDayFreshness);
export default __webpack_public_path__ + "static/media/icons_allDayFreshness.4dcf52bfa64a394763e5cfec62405be6.svg";
export { ForwardRef as ReactComponent };